/**
 * Кнопка отмены заказа для клиента.
 */
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

export function CancelButton({ order, onCancel, isLoading }) {
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showModal]);

  if (!order.can_cancel) {
    return null;
  }

  const handleCancel = () => {
    onCancel(reason);
    setShowModal(false);
    setReason('');
  };

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        disabled={isLoading}
        className="w-full bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 font-medium py-3 px-6 rounded-xl transition-colors duration-200 flex items-center justify-center gap-2"
      >
        <span>❌</span>
        <span>Отменить заказ</span>
      </button>

      {/* Модальное окно */}
      {showModal && createPortal(
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-md w-full p-6 shadow-2xl">
            <h3 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">
              Отменить заказ?
            </h3>

            {order.payment_status?.has_payment && ['succeeded', 'processing'].includes(order.payment_status?.status) && (
              <div className="bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800 rounded-lg p-3 mb-4">
                <p className="text-sm text-green-800 dark:text-green-200">
                  💰 Средства будут автоматически возвращены
                </p>
              </div>
            )}

            <p className="text-gray-600 dark:text-gray-400 mb-4">
              Вы уверены, что хотите отменить заказ #{order.id}?
            </p>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                Причина (необязательно)
              </label>
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Расскажите, почему вы отменяете заказ..."
                className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent dark:bg-gray-700 dark:text-white resize-none"
                rows={3}
              />
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
                💡 Ваш комментарий увидит администратор заведения
              </p>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => setShowModal(false)}
                className="flex-1 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 font-semibold py-3 px-6 rounded-xl transition-colors duration-200"
              >
                Назад
              </button>
              <button
                onClick={handleCancel}
                disabled={isLoading}
                className="flex-1 bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-200"
              >
                {isLoading ? 'Отмена...' : 'Отменить'}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
